import { FaFacebookF, FaGoogle, FaChartLine, FaCode } from "react-icons/fa";
import "../styles/marketingservices.css";

const services = [
  {
    icon: <FaFacebookF />,
    title: "Facebook hirdetések",
    text: "Célzott kampányok, amelyek valóban eredményt hoznak.",
  },
  {
    icon: <FaGoogle />,
    title: "Google hirdetések",
    text: "Megjelenés ott, ahol az emberek keresnek – a Google-ben.",
  },
  {
    icon: <FaChartLine />,
    title: "Kereső-optimalizálás",
    text: "Organikus forgalom növelése hosszú távon.",
  },
  {
    icon: <FaCode />,
    title: "Weboldal készítés",
    text: "Professzionális bemutatkozó oldalak vállalkozásodhoz.",
  },
];

function MarketingServices() {
  return (
    <section className="marketing-section pt-4" id="marketingservices">
      <div className="container px-4">
        <h2 className="text-center text-light mb-5">
          Online marketing szolgáltatások kisvállalkozásoknak
        </h2>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
          {services.map((service, index) => (
            <div className="col d-flex align-items-start" key={index}>
              <div className="icon text-light me-3">{service.icon}</div>
              <div>
                <h3 className="mb-1 fs-5 text-light pb-1">{service.title}</h3>
                <p className="small mb-0">{service.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarketingServices;
